module.exports = __webpack_public_path__ + "img/sh_logo.4fd6dc83.jpg";